'use client';
import ArrowDown from '@/app/_components/ui/icons/ArrowDown.svg';
import React, { useState } from 'react';

function Accordion({ data, id }) {
  const [openAccordion, setOpenAccordion] = useState(false);
  return (
    // Accordion container
    <div className="w-full bg-white">
      {/* Accordion Header */}
      <div
        onClick={() => setOpenAccordion(!openAccordion)}
        className="flex justify-between items-center md:h-[62px] w-full xs:p-3 sm:px-5 sm:py-3  md:py-0 xs:text-sm md:text-base font-bold cursor-pointer"
      >
        <h2>
          <span>{id ? id : data.id}.</span>
          <span>{data.question}</span>
        </h2>
        <span
          className={`transition-all duration-200  ${
            openAccordion ? `rotate-180` : `rotate-0`
          }`}
        >
          <ArrowDown />
        </span>
      </div>
      {/* Accordion content */}
      <div
        className={`w-full overflow-hidden px-5  transition-all duration-200  ${
          openAccordion ? `py-5 h-fit` : `py-0 h-0`
        }`}
      >
        <p className="md:text-base xs:text-sm">{data.answer}</p>
      </div>
    </div>
  );
}

export default Accordion;
